module.exports = __webpack_public_path__ + "static/img/3.1267787.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/eng/3.png
// module id = YTwA
// module chunks = 0